import React from "react";
import Box from "@mui/material/Box";

const Footer = () => {
  return (
    <footer>
      <Box>
        <span style={{ fontSize: "10px", color: "#ffff" }}>
          &copy; {new Date().getFullYear()}{" "}
          <a
            href="https://www.kaluinteriors.com.au/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Kalu Interiors.
          </a>{" "}
          All Rights Reserved.
        </span>
      </Box>
      <Box>
        <span style={{ fontSize: "10px", color: "white" }}>
          Developed by{" "}
          <a
            href="https://imaginetventures.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            ImagiNET Ventures
          </a>
        </span>
      </Box>
    </footer>
  );
};

export default Footer;
